import { RouteRecordRaw } from "vue-router"

const errorRoutes: RouteRecordRaw[] = [
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    meta: {
      title: "404 - NOT FOUND",
      hidden: true
    },
    component: () => import("@/views/Error/404/index.vue")
  }
]

export default errorRoutes
